import axiosConfig from "./axiosConfig";

export interface PingNowResponse {
  ok: boolean;
  siteId: string;
  /** Number of SIM-equipped esys that the ping Lambda checked. */
  checked?: number;
  /** Number of those checks that failed (Soracom-side error). */
  failed?: number;
  /** When the call did not succeed, the iot Lambda's error message. */
  message?: string;
}

/**
 * Synchronously trigger one extra Soracom downlink ping for this site.
 * Optional `esysUuid` narrows to a single SIM on multi-SIM sites; without
 * it every SIM-equipped esys at the site is pinged.
 *
 * The iot Lambda writes the row(s) directly into `iot_ping_check`, so
 * the caller is expected to invalidate the ping-latest + ping-history
 * queries on success.
 */
const postSitePingNow = async (
  authToken: string,
  siteId: string,
  esysUuid?: string
): Promise<PingNowResponse> => {
  const { data } = await axiosConfig.post(
    `/site/${siteId}/health/ping-now`,
    {},
    {
      headers: { Authorization: `Bearer ${authToken}` },
      params: esysUuid ? { esysUuid } : undefined,
    }
  );
  return data;
};

export default postSitePingNow;
